const topicsData = [
  { tag: '#甜宠剧推荐', hot: '128万讨论', color: 'bg-primary-100 text-primary-700' },
  { tag: '#韩剧全集', hot: '96万讨论', color: 'bg-accent-100 text-accent-700' },
  { tag: '#国产剧推荐', hot: '87万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '#情侣追剧', hot: '74万讨论', color: 'bg-primary-100 text-primary-700' },
  { tag: '#电视剧全集', hot: '63万讨论', color: 'bg-accent-100 text-accent-700' },
  { tag: '#最新电视剧', hot: '58万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '#古装仙侠', hot: '45万讨论', color: 'bg-primary-100 text-primary-700' },
  { tag: '#悬疑刑侦', hot: '39万讨论', color: 'bg-accent-100 text-accent-700' },
  { tag: '#免费在线看', hot: '32万讨论', color: 'bg-secondary-100 text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            大家都在讨论的追剧话题，加入情侣影院的追剧社区
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((item, idx) => (
            <a
              key={idx}
              href="#topics"
              className={`whitespace-nowrap group inline-flex items-center gap-2 px-5 py-3 rounded-full ${item.color} text-sm font-medium transition-all hover:scale-105`}
            >
              <span>{item.tag}</span>
              <span className="text-xs opacity-60">{item.hot}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}